import { render, staticRenderFns } from "./gradingSystemForm.vue?vue&type=template&id=67f61c3c&scoped=true&"
import script from "./gradingSystemForm.vue?vue&type=script&lang=js&"
export * from "./gradingSystemForm.vue?vue&type=script&lang=js&"
import style0 from "./gradingSystemForm.vue?vue&type=style&index=0&id=67f61c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f61c3c",
  null
  
)

export default component.exports